
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.735 2.5a.833.833 0 00-.651.313L5.25 6.353a.833.833 0 01-.65.314H1.666a.833.833 0 00-.833.833v5c0 .46.373.833.833.833H4.6c.253 0 .493.115.65.313l2.834 3.541a.833.833 0 00.65.313h2.933v-15H8.735z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M19.167 10c0 3.4-2.544 6.205-5.833 6.615v-1.684a5.002 5.002 0 000-9.862V3.385A6.668 6.668 0 0119.167 10z","fill":"#D8D8D8"}}),_c('path',{attrs:{"d":"M15.834 10a3.335 3.335 0 01-2.5 3.228v-1.784a1.666 1.666 0 000-2.888V6.772a3.335 3.335 0 012.5 3.228z","fill":"#D8D8D8"}})])
          )
        }
      }
    